import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';
import { ServiceDeskDocumentTitle } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/document-title/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { usePathParam } from '@atlassian/react-resource-router';
import App from './app';

const ItsmFeatures = () => {
	const [projectKey = ''] = usePathParam('projectKey');
	const { data: projectContext } = useProjectContext();

	return (
		<ContextualAnalyticsData
			containerType="project"
			containerId={projectKey}
			sourceName="jsdItsmFeaturesSettings"
			sourceType={SCREEN}
		>
			{projectContext && (
				<ServiceDeskDocumentTitle projectName={projectContext.projectName} section="itsmFeatures" />
			)}
			<ServiceDeskAnalyticsContext forceRenderWhileLoading>
				<App />
				{/* SpaStatePageReady is used to indicate that the app can move to the "afterPaint" phase in react-loosely-lazy. */}
				{fg('jsm_simplified_project_settings_navigation') && <SpaStatePageReady />}
			</ServiceDeskAnalyticsContext>
		</ContextualAnalyticsData>
	);
};

export default ItsmFeatures;
